import React, { useEffect, useState } from "react";
import { BundleDrawer } from "./BundleDrawer";
import { ButtonTypedButtonProps } from "@/components/Button";
import { SelectBundlePage } from "./BundleDrawer/pages/SelectBundlePage";
import { bundleDrawerData } from "@/helpers/data/bundleDrawerData";

export interface BundleDrawerButtonHandlerProps
  extends ButtonTypedButtonProps {}

export const BundleDrawerButtonHandler = (
  props: BundleDrawerButtonHandlerProps
) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const buttons = document.querySelectorAll("a[href=''],a[href='#']");
    buttons.forEach((b) => {
      (b as HTMLAnchorElement).onclick = (event) => {
        event.preventDefault();
        setOpen(true);
      };
      b.setAttribute("role", "button");
    });
  }, []);

  return (
    <>
      <BundleDrawer
        open={open}
        onExit={() => {
          setOpen(false);
        }}
        goToFirstPage={() => {}}
        title="Select your bundle"
        contents={() => (
          <SelectBundlePage
            onExit={() => setOpen(false)}
            goToFirstPage={() => {}}
            onSelect={() => {}}
            bundles={bundleDrawerData}
          />
        )}
      />
    </>
  );
};
